// src/layout/OnboardingGate.tsx
//
// Routes genuinely-new users into the two-step setup.
//
// This is the highest-risk piece of the migration: get it wrong and every
// existing student is dumped into a first-run wizard. It is therefore
// written to fail *open* at every step —
//
// · signed out → no redirect
// · preferences loading → no redirect
// · preferences errored → no redirect
// · already onboarded → no redirect
// · anywhere but "/"→ no redirect
//
// so the only path into onboarding is a successful response that explicitly
// reports `onboarding_completed_at === null`. Migration set that column for
// everyone who already existed, so in practice only real sign-ups qualify.
//
// The redirect is limited to "/" on purpose: someone opening a shared
// contest link or a deep link to a paper should land where they were going,
// not be intercepted. They'll get the prompt next time they visit home, and
// the home page asks for a branch inline regardless.

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { usePreferences } from "@/hooks/usePreferences";

export function OnboardingGate({ children }: { children: React.ReactNode }) {
  const { needsOnboarding } = usePreferences();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (needsOnboarding && pathname === "/") {
      navigate("/onboarding", { replace: true });
    }
  }, [needsOnboarding, pathname, navigate]);

  return <>{children}</>;
}
